import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import reducer from '../reducers/reducer';
import * as Sentry from '@sentry/react';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally configure Sentry enhancer
});

const sagaMiddleware = createSagaMiddleware();
const persistedState = {};

export default function configureStore() {
  const middlewareEnhancer = applyMiddleware(thunk, sagaMiddleware);

  const composedEnhancers = composeWithDevTools(
    middlewareEnhancer,
    sentryReduxEnhancer
  );

  return createStore(reducer, persistedState, composedEnhancers);
}
